module.exports = __webpack_public_path__ + "static/media/weatherStation.2cf86930.mp4";